import { render, staticRenderFns } from "./ImportingTemplate.vue?vue&type=template&id=0191680c&"
import script from "./ImportingTemplate.vue?vue&type=script&lang=js&"
export * from "./ImportingTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ImportingTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0191680c')) {
      api.createRecord('0191680c', component.options)
    } else {
      api.reload('0191680c', component.options)
    }
    module.hot.accept("./ImportingTemplate.vue?vue&type=template&id=0191680c&", function () {
      api.rerender('0191680c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Information/ImportingTemplate.vue"
export default component.exports